<template>
  <div>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <v-card>
            <v-container fluid>
              <v-layout row wrap align-center justify-space-between>
                <v-flex lg4>
                  <v-btn icon color="primary" class="ma-auto mr-2" @click="this.getList">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                  <v-btn color="info" class="ma-auto mr-2" @click="toggleAllGroupsSelected">
                    <v-icon>check</v-icon>
                    {{ isAllSelected ? 'Deselect all groups' : 'Select all groups' }}
                  </v-btn>
                  <v-btn color="error" class="ma-auto mr-2" @click="callDeleteGroupsDialog" :disabled="!selectedCount">
                    <v-icon>delete</v-icon>
                    Remove groups {{ selectedCount }}
                  </v-btn>
                </v-flex>
                <v-flex lg4>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex md12>
                  <div class="py-3"></div>
                  <v-data-table
                    dense
                    v-model="selected"
                    :loading="isLoading"
                    :headers="headers"
                    :items="list"
                    :search="search"
                    :options.sync="pagination"
                    :rowsPerPageItems="rowsPerPageItems"
                    show-select
                    item-key="key"
                  >
                    <template v-slot:item="props">
                      <tr :active="props.isSelected" :key="`row-${props.item.key}`">
                        <td class="text-start">
                          <v-checkbox
                            class="mt-0"
                            :input-value="props.isSelected"
                            @click.stop="selectRowHandler(props)"
                            hide-details
                            primary
                          ></v-checkbox>
                        </td>
                        <td>
                          <div class="pa-2">
                            <v-btn
                              small
                              icon
                              color="info"
                              class="ma-auto mr-1"
                              :to="{ name: 'smtpinput-message', params: { id: props.item.key }}">
                              <v-icon small>input</v-icon>
                            </v-btn>
                            <v-btn
                              small
                              icon
                              color="error"
                              class="ma-auto"
                              @click="callDeleteGroupDialog(props.item.key)">
                              <v-icon small>delete</v-icon>
                            </v-btn>
                          </div>
                        </td>
                        <td v-for="(value, key) in props.item" :key="`${props.item.key}-${key}`" v-if="key !== 'key'" class="pa-1">{{ value }}</td>
                      </tr>
                    </template>

                    <template v-slot:no-data>
                      <div class="pa-2 text-xs-center">No data available.</div>
                    </template>

                    <template v-slot:no-results>
                      <div class="pa-2 text-xs-center">Your search for "{{ search }}" found no results.</div>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <confirm-modal
      v-model="dialog"
      :title="removeSingleDialogTitle"
      @on-confirm="confirmDialogHandler"
    ></confirm-modal>
    <confirm-modal
      v-model="groupDialog"
      :title="removeGroupDialogTitle"
      @on-confirm="confirmDeleteGroupsDialogHandler"
      @on-cancel="cancelDeleteGroupsDialogHandler"
    ></confirm-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      groupDialog: false,
      removeSingleDialogTitle: 'Remove group with all messages ?',
      selectedGroup: '',
      search: '',
      schema: [],
      list: [],
      selected: [],
      rowsPerPageItems: [10, 20, 40, 80, 160, {"text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1}],
      pagination: {
        rowsPerPage: 10,
      },
      isLoading: false,
    }
  },
  mounted() {
    this.getList();
  },
  computed: {
    selectedCount() {
      return this.selected.length
    },
    isAllSelected() {
      return this.selectedCount === this.list.length;
    },
    removeGroupDialogTitle(){
      return this.selectedCount === 1
        ? 'Remove selected group with all messages ?'
        : `Remove ${this.selectedCount} selected groups with all messages ?`
    },
    headers() {
      const headers = [];

      headers.push({
        text: 'Actions',
        value: 'name',
        sortable: false
      });

      for (const key in this.schema.properties) {
        if (this.schema.properties[key]['x-list'] && key !== 'key') {
          let { title } = this.schema.properties[key];

          title = title.replace(title.charAt(0), title.charAt(0).toUpperCase())

          headers.push({
            text: title,
            value: key,
            align: 'left'
          });
        }
      }

      return headers;
    },
  },
  methods: {
    selectRowHandler(props) {
      props.select(!props.isSelected);
    },
    toggleAllGroupsSelected() {
      if (this.isAllSelected) {
        this.selected = [];
      } else {
        this.selected = this.list;
      }
    },
    async getList() {
      this.isLoading = true;

      const responseSchema = await this.$api.smtp.getSchema();
      this.schema = await responseSchema.data;

      const responseList = await this.$api.smtp.getList();
      this.list = await responseList.data;

      this.isLoading = false;
    },
    callDeleteGroupDialog(id) {
      this.selectedGroup = id;
      this.dialog = true;
    },
    async confirmDialogHandler() {
      const response = await this.$api.smtp.deleteGroup(this.selectedGroup);
      this.list = this.list.filter(item => item.key !== this.selectedGroup);
    },
    callDeleteGroupsDialog() {
      this.dialog = false;
      this.groupDialog = true;
    },
    async confirmDeleteGroupsDialogHandler() {
      const groupsToRemove = this.selected.map(item => item.key);
      const response = await this.$api.smtp.deleteGroupsList(groupsToRemove);

      this.list = this.list.filter(item => !groupsToRemove.some(key => item.key === key))
      this.selected = [];
    },
    cancelDeleteGroupsDialogHandler() {
      this.groupDialog = false;
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/SmtpInput/list.vue